import React, { useEffect, useState } from "react";
import api from "../api/axios";
import GroupForm from "../components/forms/GroupForm";

function Grouping() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState(null); // For edit
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const token = localStorage.getItem("accessToken");

  // Fetch groups
  const fetchGroups = async (pageNumber = 1) => {
    setLoading(true);    
    try {
      const res = await api.get(`/group-list?page=${pageNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setGroups(res.data.data);
      setPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  // Handle edit click
  const handleEdit = (group) => {
    setSelectedGroup(group);
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" }); // Scroll to form
  };

  // After save/update refresh list
  const handleFormSubmit = () => {
    fetchGroups(page);
    setSelectedGroup(null);
  };

  return (
    <>
      {/* Page Title */}
      <div className="row mb-3">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Account Heads</h4>
          <ol className="breadcrumb m-0">
            <li className="breadcrumb-item"><a href="#">Accounts</a></li>
            <li className="breadcrumb-item active">Heads</li>
          </ol>
        </div>
      </div>
      

      {/* Group List */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">Head List</h5>
            </div>
            <div className="card-body">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered ledger-table">
                    <thead>
                      <tr>
                        <th>Sl.No.</th>
                        <th>Head Name</th>
                        <th>Parent Head</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groups.length > 0 ? (
                        groups.map((group, index) => (
                          <tr key={group.id}>
                            <td>{index+1}</td>
                            <td className="fw-bold">{group.group_name}</td>
                            <td>{(1!=group.parent.id) ? group.parent.group_name : 'N.A'}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-warning"
                                onClick={() => handleEdit(group)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No groups found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => fetchGroups(page - 1)}
                  disabled={page <= 1}
                >
                  Prev
                </button>
                <span>
                  Page {page} of {lastPage}
                </span>
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => fetchGroups(page + 1)}
                  disabled={page >= lastPage}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Group Form */}
      <div className="row mb-4 mt-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">
                {selectedGroup ? "Update Head" : "Create New Head"}
              </h5>
            </div>
            <div className="card-body">
              <GroupForm
                group={selectedGroup}
                onSuccess={handleFormSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Grouping;
